import React, { useRef } from 'react';
import { motion, useMotionTemplate, useMotionValue } from 'framer-motion';
import { useTheme } from '../../context/ThemeContext';

export default function SpotlightButton({ children, onClick, className = "", href }) {
  const mouseX = useMotionValue(0);
  const mouseY = useMotionValue(0);
  const { theme } = useTheme();

  function handleMouseMove({ currentTarget, clientX, clientY }) {
    let { left, top } = currentTarget.getBoundingClientRect();
    mouseX.set(clientX - left);
    mouseY.set(clientY - top);
  }

  const gradientColor = theme === 'dark' 
    ? 'rgba(249, 115, 22, 0.5), rgba(255, 255, 255, 0.2)' // Orange + White glow for dark
    : 'rgba(30, 58, 138, 0.5), rgba(255, 255, 255, 0.4), rgba(191, 219, 254, 0.3)'; // Dark Blue + White + Light Blue for light mode

  const Content = (
    <div
      onMouseMove={handleMouseMove}
      className="group relative p-[1px] overflow-hidden bg-foreground/10 backdrop-blur-md rounded-full w-full h-full"
    >
      <motion.div
        className="pointer-events-none absolute -inset-px opacity-0 transition duration-300 group-hover:opacity-100"
        style={{
          borderRadius: '9999px',
          background: useMotionTemplate`
            radial-gradient(
              120px circle at ${mouseX}px ${mouseY}px,
              ${gradientColor},
              transparent 80%
            )
          `,
        }}
      />
      <div 
        className="relative h-full w-full bg-background/40 hover:bg-background/20 transition-colors flex items-center justify-center rounded-full"
      >
        <div className="px-10 py-4 flex items-center justify-center gap-3 text-foreground font-black uppercase tracking-widest text-[10px] whitespace-nowrap">
          {children}
        </div>
      </div>
    </div>
  );

  const finalClassName = `${className} block`;

  if (href) {
    return (
      <a href={href} className={finalClassName}>
        {Content}
      </a>
    );
  }

  return (
    <button onClick={onClick} className={finalClassName}>
      {Content}
    </button>
  );
}
